import type { ReactElement } from 'react';

import { Component as EmptyFavoriteIcon } from 'icons/icon-ui--heart-empty.svg';

function EmptyFavorites(): ReactElement {
  return (
    <div className="c-myfavorites-empty">
      <div className="c-myfavorites-empty__content u-text--center u-text--sm-left">
        <hr className="d-sm-none" />
        <div className="d-flex flex-column flex-sm-row">
          <div className="c-myfavorites-empty__icon">
            <EmptyFavoriteIcon width="26" />
          </div>
          <div>
            <h2 className="c-myfavorites-empty__title c-heading c-heading--brand-5">
              No favorites yet!
            </h2>
            <p className="c-myfavorites-empty__text">
              Click the heart on any recipe to add your favorite recipes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyFavorites;
